import React from 'react';
import amazonCardLogo from '../../assets/img/amazon-card.svg';
import paypalCardLogo from '../../assets/img/paypal-card.svg';
import jcbCardLogo from '../../assets/img/jcb-card.svg';
import masterCardLogo from '../../assets/img/master-card.svg';
import visaCardLogo from '../../assets/img/visa-card.svg';

import Categories from '../Categories/Categories';
import styles from './Footer.module.scss';

const Footer: React.FC = () => (
  <div className={styles.footerContainer}>
    <div className={styles.footerSection}>
      <div className={styles.heading}>Contact Info</div>
      <p>
        <strong>Phone</strong>
        : (+91) 9876 543 210
        <br />
        <strong>Address</strong>
        : 1418 Riverwood Drive,
        <br />
        Suite 3245 Cottonwood,
        <br />
        CA 96052, United State
      </p>
      <div className={styles.paymentOptions}>
        <strong>We accept:</strong>
        <div className={styles.paymentCards}>
          <object data={amazonCardLogo} type="image/svg+xml" className={styles.cartLogo}>
            amazon card logo
          </object>
          <object data={paypalCardLogo} type="image/svg+xml" className={styles.cartLogo}>
            paypal card ogo
          </object>
          <object data={jcbCardLogo} type="image/svg+xml" className={styles.cartLogo}>
            jcb card ogo
          </object>
          <object data={masterCardLogo} type="image/svg+xml" className={styles.cartLogo}>
            master card ogo
          </object>
          <object data={visaCardLogo} type="image/svg+xml" className={styles.cartLogo}>
            visa card ogo
          </object>
        </div>
      </div>
    </div>
    <div className={styles.footerSection}>
      <div className={styles.heading}>Categories</div>
      <Categories />
    </div>
    <div className={styles.footerSection}>
      <div className={styles.heading}>Let&lsquo;s stay in touch</div>
      <div className={styles.emailInputContainer}>
        <input type="email" placeholder="Your email address" />
        <div>Subscribe</div>
      </div>
    </div>
    <div className={styles.credits}>
      <p>2020, Little tags website</p>
      <p>All Rights Reserved</p>
    </div>
  </div>
);

export default Footer;
